<section
  class="corte-form-card"
  aria-labelledby="corte-form-titulo"
  [class.corte-form-bloqueado]="bloqueado"
>
  <div class="corte-form-grid">
    <div class="corte-field" *ngIf="mostrarSelectCor">
      <label for="corte-cor">Cor</label>
      <select
        id="corte-cor"
        class="form-control"
        [disabled]="bloqueado"
        [ngModel]="corSelecionada"
        (ngModelChange)="onCorChange($event)"
      >
        <option *ngFor="let c of cores" [ngValue]="c.id">
          {{ c.descricao || ('Cor ' + c.id) }}
        </option>
      </select>
    </div>

    <div class="corte-field" *ngIf="mostrarSelectTamanho">
      <label for="corte-tamanho">Tamanho</label>
      <select
        id="corte-tamanho"
        class="form-control"
        [disabled]="bloqueado"
        [ngModel]="tamanhoSelecionado"
        (ngModelChange)="onTamanhoChange($event)"
      >
        <option *ngFor="let t of tamanhos" [ngValue]="t">{{ t }}</option>
      </select>
    </div>

    <div class="corte-field corte-field-qtd">
      <label for="corte-qtd">Quantidade</label>
      <div class="corte-stepper" role="group" aria-label="Ajustar quantidade">
        <div class="corte-stepper-input-wrap">
          <input
            id="corte-qtd"
            type="number"
            class="form-control corte-stepper-input"
            min="1"
            step="1"
            [readonly]="bloqueado"
            [(ngModel)]="qtdStr"
            (ngModelChange)="limparErroSomenteQuantidade()"
          />
          <button
            type="button"
            class="corte-stepper-btn corte-stepper-btn-inner"
            aria-label="Diminuir quantidade"
            [disabled]="bloqueado || qtdInt <= 1"
            (click)="decrementQtd()"
          >
            <svg class="corte-stepper-ico" viewBox="0 0 16 16" aria-hidden="true" focusable="false">
              <rect x="2" y="7" width="12" height="2" rx="0.5" fill="currentColor" />
            </svg>
          </button>
        </div>
        <button
          type="button"
          class="corte-stepper-btn corte-stepper-btn-plus"
          aria-label="Aumentar quantidade"
          [disabled]="bloqueado"
          (click)="incrementQtd()"
        >
          <svg class="corte-stepper-ico" viewBox="0 0 16 16" aria-hidden="true" focusable="false">
            <path
              fill="currentColor"
              d="M7 2h2v5h5v2h-5v5H7v-5H2V7h5V2z"
            />
          </svg>
        </button>
      </div>
    </div>
    <div class="corte-field corte-field-grow">
      <label for="corte-comp">Comprimento (m)</label>
      <div class="corte-stepper" role="group" aria-label="Ajustar comprimento em metros">
        <div class="corte-stepper-input-wrap">
          <input
            id="corte-comp"
            type="text"
            class="form-control corte-stepper-input"
            [class.is-invalid]="erro"
            placeholder="Ex: 1,20"
            [readonly]="bloqueado"
            [(ngModel)]="compStr"
            (ngModelChange)="onCompChange()"
          />
          <button
            type="button"
            class="corte-stepper-btn corte-stepper-btn-inner"
            aria-label="Diminuir comprimento em 0,10 m"
            [disabled]="bloqueado || compNumero === null || compNumero <= 0.1"
            (click)="decrementComp()"
          >
            <svg class="corte-stepper-ico" viewBox="0 0 16 16" aria-hidden="true" focusable="false">
              <rect x="2" y="7" width="12" height="2" rx="0.5" fill="currentColor" />
            </svg>
          </button>
        </div>
        <button
          type="button"
          class="corte-stepper-btn corte-stepper-btn-plus"
          aria-label="Aumentar comprimento em 0,10 m"
          [disabled]="bloqueado"
          (click)="incrementComp()"
        >
          <svg class="corte-stepper-ico" viewBox="0 0 16 16" aria-hidden="true" focusable="false">
            <path
              fill="currentColor"
              d="M7 2h2v5h5v2h-5v5H7v-5H2V7h5V2z"
            />
          </svg>
        </button>
      </div>
      <p class="corte-comp-hint" [class.text-danger]="!!erro">
        {{ erro || "Use múltiplos de 0,10 m (ex: 0,50, 1,20, 3,00)." }}
      </p>
    </div>
    <div class="corte-form-actions">
       <ng-container *ngIf="editando; else btnAdicionar">
        <button
          type="button"
          class="btn btn-warning rounded-pill px-4"
          [disabled]="bloqueado || !!erro"
          (click)="submit()"
        >
          Salvar
        </button>
        <button
          type="button"
          class="btn btn-outline-secondary rounded-pill px-3"
          [disabled]="bloqueado"
          (click)="limpar(true)"
        >
          Cancelar
        </button>
      </ng-container> 
      <ng-template #btnAdicionar>
        <button
          type="button"
          class="btn btn-success rounded-pill px-4 corte-btn-adicionar"
          [disabled]="bloqueado || !!erro"
          (click)="submit()"
        >
          Adicionar
        </button>
      </ng-template>
    </div>
  </div>
</section>
